/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

const mustToShow = !Odigeo.AB.isFrontendShellEnabled && Odigeo.AB.isFareUpgradeEnabled && !Odigeo.AB.isFareUpgradePaxEnabled;

Odigeo.defineWidget('fare_upgrade_manager', Odigeo.Widget.extend({
    modelClass: mustToShow ? require('./model') : null,
    viewClass: mustToShow ? require('./view') : null,

    getFareFamilies: function(data) {
        this.view.empty();
        this.model.update(data);
    },
    checkFareUpgrades: function(data) {
        this.view.empty();
        this.model.set(data);
        Odigeo.trigger(this.id + ':setIsFareUpgradeAvailable', this.model.checkScope());
    },
    checkFareUpgradesDisplay: function(data) {
        this.view.empty();
        this.model.set(data);
        return this.model.checkScope();
    },
    init: Odigeo._.noop,
}));
